export default __webpack_public_path__ + "static/media/reddit_logo.f34cb31d.svg";